import {
    AddCircleRounded,
    LogoDevRounded,
    RemoveCircleRounded,
    SoupKitchen,
    } from "../../ui/icons";
import {
  Grid,
    IconButton,
    InputAdornment,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    } from "../../ui";
import React,
    { useEffect,
    useMemo,
    useState } from "react";
import EditIcon from "../../ui/icons/Edit";
import DeleteIcon from "../../ui/icons/Delete";
import { useDispatch,
    useSelector } from "react-redux";
import {
  BillStatus,
  getAuthSession,
  DELETEREASON,
  detectBrowser,
  FAILED,
  formatDateinStyled,
  GENERATEBILL,
  GETBILLPRODUCTBYPRDID,
  getDeviceTypeNew,
  GETKOTBYITEM,
  getPreUrlAccordingToCart,
  isEmpty,
  isNumberEmpty,
  OfferType,
  PARTILBILLAUDIT,
  PayMedium,
  PRINT_RESTO_KOT_ITEM,
  PRICE_CHANGE_IN_BILL,
  printDebugLog,
  SUCCESS
} from "../../../constants/constant";
import { isFeatureAllowed, STOCKMGMT } from "../../../constants/constant";
import {
  addCachedBillProductDetails,
  addDeletedBillItem,
  removeItemFromBill,
  updateBillDetails,
  updateBillItem,
  updateBillPartialPaymentDetails,
  updateBillPaymentDetails,
} from "../../../store/billDetailsSlice";
import CustomDataGrid from "../../global/CustomDataGrid";
import BillItemEdit from "./BillItemEdit";
import BillItemDelete from "./BillItemDelete";
import {
  INITIAL_BILL_STOCK_DATA,
  INITIAL_STOCK_DATA,
} from "./RestBillConstants";
import axios from "axios";
import { snpAxios } from "../../global/api";
import printJS from "print-js";
import { useSnpUI } from "../../global/snpComponent/SnpUiProvider";
import { handleInvoicePrint } from "../../../utilities/printUtils";
import { getConfigValueByKey } from "../../../utilities/commonUtilities";
import {
  INITIAL_BILL_ITEM_STATE,
  INITIAL_BILL_PAYMENT_DETAILS_STATE,
  INITIAL_PRODUCT_DETAILS_STATE,
} from "../../../constants/restoConstant";
import { useDeviceType } from "../../global/hooks/useDeviceType";
import { Navigate, useNavigate } from "react-router-dom";
import Loader from "../../global/loader/Loader";
import { recalculateBillTotal } from "../../../store/thunk/billCalculatorThunk";
import SimpleCircularLoader from "../../global/loader/SimpleCircularLoader";
import BillManagementOtpDialog from "./BillManagementOtpDialog";
import { set } from "lodash";
import RestoUnitSelector from "../RestoUnitSelector";
import {
  applyRestoPriceChange,
  calculateRestoConversionPrice,
  getRestoAvailableStock,
  getRestoConversion,
  isRestoQuantityAllowed,
  isRestoStockQuantityAllowed,
} from "../restoBillingConversion";

export const generateBillItemsColumns = (
  handleAction,
  handleQuantityChage,
  handleItemModication,
  isPaid,
  payLaterSignal,
  snackbar,
  priceChangeAllowed,
  handlePriceChange,
  handleUnitChange
) => {
  return [
    {
      field: "prddets",
      headerName: "Item",
      flex: 1,
      minWidth: 250,
      renderCell: (val) => {
        let data = val.row.name;
        if (val.row.foodQuantityName)
          data = data + "(" + val.row.foodQuantityName + ")";
        return <div>{data}<RestoUnitSelector item={val.row} disabled={isPaid || payLaterSignal}
          onChange={handleUnitChange} /></div>;
      },
    },
    {
      field: "quantity",
      headerName: "Qty",
      flex: 1,
      minWidth: 180,
      editable: true,
      renderCell: (val) => {
        return (
          <Grid container spacing={0}>
            <Grid item md={12} sm={12} xs={12} lg={12}>
              <TextField
                id="colQuantity"
                //className={colQuantityClasses.input}
                name="colQuantity"
                type="number"
                inputProps={{
                  inputMode: getRestoConversion(val.row)?.decimalSmRestrictions
                    ? "numeric" : "decimal",
                  step: getRestoConversion(val.row)?.decimalSmRestrictions ? 1 : "any",
                  min: 0,
                }}
                value={Number(val.row.quantity)}
                variant="standard"
                size="small"
                disabled={isPaid}
                sx={{
                  justifyContent: "center",
                  alignContent: "center",
                  "& .UiInputBase-input": {
                    textAlign: "center",
                  },
                }}
                onChange={(e) => handleItemModication(val.row, e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <IconButton
                        disabled={isPaid}
                        onClick={() =>
                          handleQuantityChage(
                            val.row,
                            Number(val.row.quantity) + 1
                          )
                        }
                      >
                        <AddCircleRounded
                          color="success"
                          sx={{
                            fontSize: "2rem",
                          }}
                        />
                      </IconButton>
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        disabled={isPaid}
                        onClick={() =>
                          handleItemModication(
                            val.row,
                            Number(val.row.quantity) - 1
                          )
                        }
                      >
                        <RemoveCircleRounded
                          color="warning"
                          sx={{
                            fontSize: "2rem",
                          }}
                        />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
        );
      },
    },
    {
      field: "savedQuantity",
      headerName: "P.Qty",
      flex: 1,
      minWidth: 50,
    },
    {
      field: "price",
      headerName: "Price",
      minWidth: 100,
      flex: 1,
      renderCell: (val) => {
        return priceChangeAllowed && !isPaid && !payLaterSignal ? (
          <TextField
            type="number"
            inputMode="decimal"
            size="small"
            value={val.row.price}
            inputProps={{ min: 0, step: "0.01" }}
            onChange={(event) => handlePriceChange(val.row, event.target.value)}
          />
        ) : "\u20B9 " + val.row.price;
      },
    },
    // {
    //     field: 'offer', headerName: 'Offer', flex: 1,
    //     renderCell: (val) => {
    //         return (parseInt(val.row.offerDenom) === OfferType.No_Offer) ?
    //             0.0 : (parseInt(val.row.offerDenom) === OfferType.Percentage) ? val.row.offerAmt + "%" : "Flat" + val.row.offerAmt;
    //     }
    // },
    // what is this finalPrice?
    {
      field: "finalPrice",
      headerName: "T. Price",
      minWidth: 100,
      flex: 1,
      renderCell: (val) => {
        return "\u20B9 " + val.row.finalPrice;
      },
    },
    {
      field: "edit",
      headerName: "Edit",
      minWidth: 100,
      flex: 1,
      renderCell: (cellValues) => {
        return (
          <EditIcon
            disabled={isPaid || payLaterSignal}
            style={{ cursor: "pointer" }}
            onClick={(event) => {
              if (payLaterSignal)
                snackbar.show({
                  message: "Paid bill cannot be edited(Paid from Hotel Pay)",
                  color: "red",
                });
              else handleAction(cellValues);
            }}
          ></EditIcon>
        );
      },
    },
    {
      field: "delete",
      headerName: "Delete",
      minWidth: 100,
      flex: 1,
      renderCell: (cellValues) => {
        return (
          <DeleteIcon
            style={{ cursor: "pointer" }}
            disabled={isPaid || payLaterSignal}
            onClick={(event) => {
              if (payLaterSignal)
                snackbar.show({
                  message: "Paid bill cannot be deleted(Paid from Hotel Pay)",
                  color: "red",
                });
              else handleAction(cellValues);
            }}
          ></DeleteIcon>
        );
      },
    },
    {
      field: "kot",
      headerName: "KOT",
      minWidth: 100,
      flex: 1,
      renderCell: (cellValues) => {
        return (
          <SoupKitchen
            style={{ cursor: "pointer" }}
            onClick={(event) => {
              handleAction(cellValues);
            }}
          ></SoupKitchen>
        );
      },
    },
  ];
};
const BillItemList = () => {
  const [showEditDialog, setShowEditDialog] = useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedProduct, setSelectedProduct] = useState(
    INITIAL_BILL_ITEM_STATE
  );
  const [selectedBillItem, setSelectedBillItem] = useState(
    INITIAL_PRODUCT_DETAILS_STATE
  );
  const {
    billItems,
    billDetails,
    billPaymentDetails,
    billCachedProductDetails,

    billItemsFetch,
  } = useSelector((state) => state.bill);

  const storeApiUrl = useSelector(
    (state) => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL
  );
  const storeActiveShopHash = useSelector(
    (state) => state.setActiveShopHashReducer.activeShopHash
  );

  const restoBillConfig = useSelector((state) => state.restoBillConfig);
  const [partialPayOption, setPartialPayOption] = useState(false);
  const { snackbar, loader, dialog, notify } = useSnpUI();
  const { isMobile, isTablet } = useDeviceType(getDeviceTypeNew);
  const [showBillOtpDialog, setShowBillOtpDialog] = useState(false);
   const [showBillOtpDialogForQuantity, setShowBillOtpDialogForQuantity] = useState(false);
  const [updatedQuantity, setUpdatedQuantity] = useState(0);

  // setDelItemDialog({
  //   delItemDialog,
  //   showDialog: true,
  //   prdId: event.row.prdId,
  //   delReason: "",
  //   prdName: event.row.name,
  // });

  useEffect(() => {
    // re-render the component with the new billDetails
  }, [billDetails, billPaymentDetails, billItems]);

  const [deleteItemDialogData, setDeleteItemDialogData] = useState({
    showDialog: false,
    productId: 0,
    productName: "",
    deleteReason: "",
  });
  useEffect(() => {
    console.log("billDetails: ", billDetails);
    setPartialPayOption(getConfigValueByKey(restoBillConfig, PARTILBILLAUDIT));
  }, []);

  const kotDisplay = (prdId) => {
    let dUrl =
      storeApiUrl.BACKEND_BASE_URL +
      GETKOTBYITEM +
      "/" +
      getAuthSession().apiToken +
      "/" +
      billDetails.billNo +
      "/" +
      storeActiveShopHash.id +
      "/" +
      prdId;
    let data = {};
    loader.show();
    axios
      .get(dUrl, data)
      .then((response) => {
        //printLog("kotDisplay<=",response.data);
        loader.hide();
        if (response.data.status === SUCCESS) {
          let kots = response.data.jcJson.kots;
          dialog.show({
            positiveReq: true,
            negativeReq: true,
            positiveAction: "Print",
            negativeAction: "Dismiss",
            iconContent: <SoupKitchen />,
            iconReq: false,
            cancelExtra: true,
            requestType: 99,
            onConfirmAction: () => {
              printKotItmeWise(prdId);
            },
            gui: buildKotDisplayData(response.data.jcJson.prdName, kots),
          });
        } else if (response.data.status === FAILED) {
          dialog.show({
            subTitle: "Still Bill not reached to KOT state!",
            positiveReq: false,
            negativeReq: true,
            negativeAction: "Ok!",
            iconReq: false,
            cancelExtra: true,
            outSideClickDismiss: true,
            requestType: 2,
            // onCancel: () => { Navigate()},
          });
        }
      })
      .catch((error) => {
        loader.hide();
        dialog.show({
          subTitle: "Still Bill not reached to KOT state!",
          positiveReq: false,
          negativeReq: true,
          negativeAction: "Ok!",
          iconReq: false,
          cancelExtra: true,
          outSideClickDismiss: true,
          requestType: 2,
          // onCancel: () => {
          //   navigate()
          // }
        });
        printDebugLog("error : ", error);
        //window.location.href = "#/error";
      });
  };

  const priceChangeAllowed = getConfigValueByKey(restoBillConfig, PRICE_CHANGE_IN_BILL);

  const handlePriceChange = (item, value) => {
    const changedPrice = Number(value);
    if (!Number.isFinite(changedPrice) || changedPrice < 0) return;
    const pricedItem = applyRestoPriceChange(item, changedPrice);
    dispatch(recalculateBillTotal({
      prevTotalPrice: Number(item.finalPrice) || 0,
      newTotalPrice: pricedItem.finalPrice,
    }));
    dispatch(updateBillItem({
      ...item,
      ...pricedItem,
    }));
  };

  const printKotItmeWise = (prdId) => {
    //printLog("printKotItmeWise",e.target.id);
    loader.show();
    let catgUrl =
      storeApiUrl.BACKEND_BASE_URL +
      PRINT_RESTO_KOT_ITEM +
      "/" +
      getAuthSession().apiToken +
      "/" +
      billDetails.billNo +
      "/" +
      storeActiveShopHash.id +
      "/" +
      prdId;
    let data = {};
    //printLog("printKotItmeWise => ", catgUrl);
    axios
      .get(catgUrl, data)
      .then((response) => {
        //printLog(response.data);
        loader.hide();
        if (response.data !== "") {
          handleInvoicePrint({
            printRef: response.data,
            name: "kot_item",
            apiToken: getAuthSession().apiToken,
            shopId: storeActiveShopHash.id,
            billNo: billDetails.billNo,
            backendBaseUrl: storeApiUrl.BACKEND_BASE_URL,
            printOptions: { isMobile: isMobile || isTablet, silentChannel: "kot_item", silentData: { itemId: prdId } },
            //setShowCustCopyDialog, // optional
          });
        }
      })
      .catch((error) => {
        printDebugLog("error : ", error);
        loader.hide();
        //printLog("error : ", error);
        //window.location.href = "#/error";
      });
  };
  
  const handleItemModication = (rowData, updatedQuantity) => {
    const generateBillRestriction = getConfigValueByKey(
      restoBillConfig,
      GENERATEBILL
    );
    if (generateBillRestriction && !isEmpty(billDetails.generateOtp)) {
      setUpdatedQuantity(updatedQuantity);
      setSelectedBillItem(rowData);
      setShowBillOtpDialogForQuantity(true);
    } else {
      handleQuantityChage(rowData, updatedQuantity)
    }
  };
  /////////////////////////////////////////////////////

  const buildKotDisplayData = (prodName, kots) => {
    return (
      <>
        {!isEmpty(kots) && (
          <TableContainer component={Paper}>
            <Table aria-label="simple table" className="rate_card">
              <TableHead>
                <TableRow>
                  <TableCell align="center">Kot No.</TableCell>
                  <TableCell align="center">Name</TableCell>
                  <TableCell align="center">Quan.</TableCell>
                  <TableCell align="center">On</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {kots &&
                  kots.map((singleKot) => {
                    return (
                      <TableRow
                        className="rate_card--row"
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell align="center">{singleKot.count}</TableCell>
                        <TableCell align="center">
                          <p
                            style={{
                              whiteSpace: "pre-wrap",
                              overflowWrap: "break-word",
                            }}
                          >
                            {prodName}
                          </p>
                        </TableCell>
                        <TableCell align="center">
                          {(singleKot.positive ? "+" : "-") +
                            singleKot.quantity}
                        </TableCell>
                        <TableCell align="center">
                          <p
                            style={{
                              whiteSpace: "pre-wrap",
                              overflowWrap: "break-word",
                            }}
                          >
                            {formatDateinStyled(singleKot.createdOn)}
                          </p>
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </>
    );
  };
  const handleQuantityChage = (cellData, updatedQuantity) => {
    console.log("new data after quantity change: ", cellData, updatedQuantity);
    if (billDetails.isPaid) {
      snackbar.show({
        message: "Paid Dish Can't be Changed",
        color: "red",
      });
      return;
    }
    if (!isRestoQuantityAllowed(cellData, updatedQuantity)) {
      snackbar.show({
        message: "Quantity cannot contain decimal or fraction",
        color: "red",
      });
      return;
    }
    let quantity = isEmpty(updatedQuantity) ? 0 : parseFloat(updatedQuantity);
    // check if quantity is exxeding stock count
    // let stockSingleData = { unitCount: 10 }; //mock data
    if (quantity < 0) {
      snackbar.show({
        message: "Quantity can't be negative",
        color: "red",
      });
    } else if (isFeatureAllowed(STOCKMGMT)
      && !isRestoStockQuantityAllowed(cellData, quantity, cellData.selectedUnit)) {
      const availableStock = getRestoAvailableStock(cellData, cellData.selectedUnit);
      snackbar.show({
        message: `Exceeds available stock (${availableStock} ${cellData.selectedUnit || ""})`,
        color: "red",
      });
      console.log("out of stock", quantity);
      console.log("stockSingleData", selectedProduct);
    } else {
      // if (quantity <= 0) {
      //     quantity = 0.5;
      // }
      // if (isNumberEmpty(quantity)) {""
      //     quantity = 0;
      // }

      const updatedBillItem = calculateRestoConversionPrice(cellData, quantity, cellData.selectedUnit);
      if (updatedBillItem.price > 0.0) {
        console.log("updatedBillItem: ", updatedBillItem);
        const oldPrice = parseFloat(cellData.finalPrice);

        //Cution: there should not be item wise gst
        dispatch(
          recalculateBillTotal({
            prevTotalPrice: oldPrice,
            newTotalPrice: updatedBillItem.finalPrice,
          })
        );
        dispatch(updateBillItem({ ...cellData, ...updatedBillItem }));
        snackbar.show({
          message:
            quantity + "* " + getProductName(cellData) + " added successfully",
          color: "green",
          vertical: "top",
          horizontal: "right",
        });
      }
    }
  };

  const handleUnitChange = (item, selectedUnit) => {
    if (isFeatureAllowed(STOCKMGMT)
      && !isRestoStockQuantityAllowed(item, item.quantity, selectedUnit)) {
      const availableStock = getRestoAvailableStock(item, selectedUnit);
      snackbar.show({
        message: `Exceeds available stock (${availableStock} ${selectedUnit})`,
        color: "red",
      });
      return;
    }
    const updatedItem = calculateRestoConversionPrice(item, item.quantity, selectedUnit);
    dispatch(recalculateBillTotal({
      prevTotalPrice: Number(item.finalPrice) || 0,
      newTotalPrice: updatedItem.finalPrice,
    }));
    dispatch(updateBillItem({ ...item, ...updatedItem }));
  };
  const getProductName = (data) => {
    let name = data.name;
    if (!isEmpty(data.price.name)) name = name + "(" + data.price.name + ")";
    return name;
  };

  const handleBillEditWithOtp = (billItemDetails) => {
        setShowEditDialog(true);
        const product = billCachedProductDetails.find(
          (product) => product.id === billItemDetails.prdId
        );
        console.log("product: ", product);

        if (product) {
          //let prvsVal = selectedProductData[index];
          // setItemDetailsOnEdit(opt, prvsVal);
          console.log("billDetails: ", billItemDetails);
          console.log("productDets: ", product);
          setSelectedBillItem({ ...selectedBillItem, ...billItemDetails });
          setSelectedProduct({ ...selectedProduct, ...product });
        } else {
          getProductDataByonEdit(billItemDetails);
        }
  };
  const getProductDataByonEdit = async (billItem) => {
    loader.show();
    //  ;
    let catgUrl =
      storeApiUrl.BACKEND_BASE_URL +
      getPreUrlAccordingToCart(storeActiveShopHash.cartType) +
      GETBILLPRODUCTBYPRDID;
    let data = {
      jcJson: {
        value: getAuthSession().apiToken,
        value_1: billItem.prdId,
        isCombo: billItem.combo,
      },
    };
    //printLog("getProductDataByonEdit => ",data);
    snpAxios
      .post(catgUrl, data)
      .then((response) => {
        loader.hide();
        //printLog("getProductDataByonEdit => ",response.data);
        if (response.data.status === SUCCESS) {
          // setSelectedProductData(oldArray => [...oldArray, response.data.jcJson]);
          //setItemDetailsOnEdit(opt, response.data.jcJson);
          setSelectedBillItem({ ...selectedBillItem, ...billItem });
          setSelectedProduct({ ...selectedProduct, ...response.data.jcJson });
          dispatch(addCachedBillProductDetails(response.data.jcJson));
        } else {
          snackbar.show({
            message: "No Data Found",
            color: "red",
          });
          //window.location.href = "#/error";
        }
      })
      .catch((error) => {
        // setShowItemEditDialog(false);
        loader.hide();
        printDebugLog("Error in fetching product data : ", error);
        //window.location.href = "#/error";
      });
  };
  const handleBillItemAction = (rowDetails) => {
    printDebugLog("handleBillItemAction", rowDetails);
    printDebugLog("handleBillItemAction.row", rowDetails.row);
    const { field } = rowDetails;
    printDebugLog("rowDetails: ", field);
    console.log("::billDetails::: ", billDetails);
    if (!billDetails.isPaid) {
      if (field === "edit") {
        const generateBillRestriction = getConfigValueByKey(
          restoBillConfig,
          GENERATEBILL
        );
        if (generateBillRestriction && !isEmpty(billDetails.generateOtp)) {
          setShowBillOtpDialog(true);
          setSelectedBillItem(rowDetails.row);
        } else {
          handleBillEditWithOtp(rowDetails.row);
        }
      } else if (field === "delete") {
        // is this all function only for delete product? can we make it simple
        // what does this mean that we are deleting product if the bill is not saved
        printDebugLog("handleCellClick delete");
        console.log("billDetails.billNo", billDetails.billNo);

        if (isEmpty(billDetails.billNo)) {
          var index = billItems.findIndex(
            (singleValue) => singleValue.prdId === rowDetails.row.prdId
          );
          printDebugLog("handleCellClick delete prd", rowDetails.row.prdId);
          if (index !== -1) {
            printDebugLog("handleCellClick b", index);
            let oldPrice =
              parseFloat(billItems[index].price) * billItems[index].quantity;
            dispatch(
              recalculateBillTotal({
                prevTotalPrice: oldPrice,
                newTotalPrice: 0.0,
              })
            );
            //printLog("handleCellClick ", listbillingData.value_2);
            dispatch(removeItemFromBill(billItems[index]));
            dispatch(addDeletedBillItem(billItems[index]));
          }
        } else {
          const isDeleteReasonAllowed = getConfigValueByKey(
            restoBillConfig,
            DELETEREASON
          );
          if (isDeleteReasonAllowed) {
            // setDelItemDialog({
            //   delItemDialog,
            //   showDialog: true,
            //   prdId: event.row.prdId,
            //   delReason: "",
            //   prdName: event.row.name,
            // });
            setDeleteItemDialogData({
              showDialog: true,
              productId: rowDetails.row.prdId,
              productName: rowDetails.row.name,
              deleteReason: "",
            });
          } else {
            setDeleteItemDialogData({
              showDialog: true,
              productId: rowDetails.row.prdId,
              productName: rowDetails.row.name,
              deleteReason: "",
            });
          }
        }
      }
    } else {
      snackbar.show({
        message: "Paid bill cannot be edited/deleted",
        color: "red",
      });
    }
    if (field === "kot") {
      console.log("rowDetails-kot: ", rowDetails);
      kotDisplay(rowDetails.row.prdId);
    }
  };

  const memoizedData = useMemo(() => {
    console.log("fetched bill items from data: ", billItems);
    return billItems.map((item) => item); // Example:some preprocessing
  }, [billItems]);
  return (
    <div>
      {billItemsFetch.loading ? (
        <Loader />
      ) : (
        <CustomDataGrid
          getRowId={(row) => row.prdId}
          rows={memoizedData}
          columns={generateBillItemsColumns(
            handleBillItemAction,
            handleQuantityChage,
            handleItemModication,
            billDetails.isPaid,
            billPaymentDetails.payLaterSignal,
            snackbar,
            priceChangeAllowed,
            handlePriceChange,
            handleUnitChange
          )}
        />
      )}

      <BillItemDelete
        deleteItemData={deleteItemDialogData}
        setDeleteItemData={setDeleteItemDialogData}
      />
      <BillItemEdit
        showEditDailog={showEditDialog}
        setShowEditDialog={setShowEditDialog}
        isPaid={false}
        productDetails={selectedProduct}
        billItemDetails={selectedBillItem}
      />
      <BillManagementOtpDialog
        showDialog={showBillOtpDialogForQuantity}
        setShowDialog={setShowBillOtpDialogForQuantity}
        handleGenerateBillWithOtp={() =>  handleQuantityChage(selectedBillItem, updatedQuantity)}
        title="Reduce Item Quantity"
      />
      <BillManagementOtpDialog
        showDialog={showBillOtpDialog}
        setShowDialog={setShowBillOtpDialog}
        handleGenerateBillWithOtp={() =>  handleBillEditWithOtp(selectedBillItem)}
        title="Edit Item"
      />
    </div>
  );
};

// Wrapping with React.memo to prevent unnecessary re-renders
export default React.memo(BillItemList);
